import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ClientLocation} from '../../clients-module/models/clientLocation';
import {LocationListingType} from './locationListingType';

@Component({
  selector: 'app-drag-drop-location',
  templateUrl: './drag-drop-location.component.html',
  styleUrls: ['./drag-drop-location.component.less']
})
export class DragDropLocationComponent implements OnInit {

  @Input()
  public location: ClientLocation;

  @Input()
  public type: LocationListingType;

  @Output()
  public addRemovedClicked: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  public ngOnInit(): void {
  }

  public add(): void {
    this.addRemovedClicked.emit(this.type);
  }

  public remove(): void {
    this.addRemovedClicked.emit(this.type);
  }
}

